export default __webpack_public_path__ + "locales/hy-AM/WebPlugins.json?hash=4d32dc4b0efbc8a258d9df1d0ee3f951";